import { useState, useRef, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import SignaturePad from 'react-signature-canvas'
import '../formcomponents/ElectronicSignature.css'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { Grid, Box, Paper, Stack, useMediaQuery } from '@mui/material'
import { Typography, Button } from '@nwh-consumer-digital/nw-component-lib'
import ErrorMessage from '../formcomponents/errorMessage'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'

const Item = styled(Paper)(({ theme }) => ({
  textAlign: 'left',
  minHeight: '65px',
  lineHeight: '60px',
}))

const styles = {
  signatureSectionCont: {
    padding: '10px',
  },
  errorMsgCont: {
    display: 'block',
    clear: 'both',
    width: '100%',
    paddingTop: '40px',
  },
}

const minorPageThree = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)')

  // Use Context Provider to Update Progress
  const { updateProgress } = useProgress()

  // Set Value For Progress
  updateProgress(80)

  //Scroll to top when page mounts
  const scrolltoTop = function () {
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    scrolltoTop()
  }, [])

  // Setup Ref for Signature Pad Container and Handle Error States  const cardRef = useRef(null)
  const cardRef = useRef(null)

  const removeBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '1px solid #cccccc'
    }
  }
  const addBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '3px solid red'
    }
  }

  const handleSignature = () => {
    setTimeout(() => {
      setIsSigned(true)
    }, 300)
    removeBottomBorderRed()
  }

  const { SubmissionState, onFormStateChange } = props
  const {
    register,
    handleSubmit,
    setValue,
    formState: {},
  } = useForm()
  const [isSigned, setIsSigned] = useState(false)
  const [imageURL, setImageURL] = useState(null)
  const signData = useRef({})

  const setCardColor = function (color) {
    let SigCardSt = document.getElementsByClassName('Card')
    let SigPadBk = document.getElementsByClassName('SigPad')
    SigPadBk[0].style.backgroundColor = color
    SigCardSt[0].style.backgroundColor = color
  }

  const clear = () => {
    setImageURL('reset')
    addBottomBorderRed()
    setIsSigned(false), signData.current.clear(), setCardColor('#FAFAFA')
  }

  const save = () =>
    setImageURL(
      signData.current.getTrimmedCanvas().toDataURL('image/png'),
      setValue('imageURLStr', 'True'),
      setCardColor('#E8F0FE'),
      setIsSigned(true),
    )

  const saveifNotEmpty = () => {
    if (signData.current.isEmpty()) {
      alert('You must sign document')
    } else {
      save()
    }
  }

  const handleRegistration = (data) => {
    if (imageURL) {
      setValue('imageURLStr', 'True')
      setIsSigned(true)
    }

    data.imageUrl = imageURL
    data.uploadFiles = 'See Folder Images'
    SubmissionState.sec = data
    SubmissionState.sectionThreeForm = data
    SubmissionState.sectionThreSubmitted = true
    SubmissionState.goBackPageOne = false
    SubmissionState.goBackPageTwo = false
    SubmissionState.goBackLogin = false
    SubmissionState.submitCompletedForm = true
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.showPageThree = false
    SubmissionState.showPageTwo = true
    SubmissionState.goBackPageTwo = true
    SubmissionState.goPageThree = false
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container spacing={1} justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: { xs: '1.25rem', sm: '1.25rem', md: '1.25rem', lg: '2rem', xl: '2rem' },
            marginBottom: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; 您的信息</IformBreadcrumb>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h1" style={{ marginBottom: 24 }}>
            在下方签名即代表本人确认并同意:
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Item elevation={0}>
            <Typography type="body" size="large" weight="light">
              <ul>
                <li>本人是上述患者的父母或法定监护人。</li>
                <li>没有任何法院命令或限制令限制本人查阅上述子女的医疗记录和/或信息。</li>
                <li>本人必须遵守 Northwell 网站上有关在 Northwell 患者门户网站上访问本人子女信息的条款和条件。</li>
                <li>
                  Northwell 提供 Northwell 患者门户网站访问权限是为了方便患者和家属，Northwell 可随时出于任何
                  原因撤销本人访问 Northwell 患者门户网站的权限。
                </li>
                <li>
                  本人了解，代理人的可访问内容包括选自本人子女医疗记录的有限医疗信息。本人可以通过其他方式
                  索取本人子女的完整医疗记录副本。
                </li>
                <li>本人了解，在本人子女年满 13 岁后，其账户的代理人访问权限将自动终止。</li>
                <li>
                  本人特此证明，本人是本表所列患者的父母或法定监护人，有权获取其健康信息。（如适用，请附上佐证法
                  律文件）。
                </li>
              </ul>
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 24 }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            本人特此证明，本人是本表所列患者的父母或法定监护人，有权获取其健康信息。（如适用，请附上佐证法 律文件）。
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12}>
            <Item elevation={0}>
              <div className="Card" ref={cardRef}>
                <Typography type="body" size="small" weight="plain" style={{ marginTop: 10, marginLeft: 16 }}>
                  {' '}
                  Signature required<span className="red"> *</span>
                </Typography>{' '}
                <div className="SigContainer">
                  <SignaturePad
                    onEnd={handleSignature}
                    penColor="black"
                    canvasProps={{ className: 'SigPad' }}
                    ref={signData}
                  />
                  <div>{!isSigned ? <ErrorMessage message="A signature is required." /> : null}</div>
                  <Stack spacing={2} direction={isMobile ? 'column' : 'row'}>
                    <Button size="medium" color="primary" onClick={saveifNotEmpty} type="submit" text="Submit" />
                    <Button size="medium" color="secondary" onClick={clear} type="button" text="Reset Signature" />
                  </Stack>
                </div>
              </div>
              <input {...register('imageURLStr', { required: true })} type="hidden" />
              <div style={styles.errorMsgCont}></div>
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}
export default minorPageThree
